import { toast } from "react-toastify";
import { BASE_URL } from "./connectionUrl";

export const dataUpload = async (token, formData, type) => {
    try {
        const response = await fetch(
            `${BASE_URL}/api/v1/admin/reports/import_data/${type}`,
            {
                method: "POST",
                headers: {
                    Authorization: `Token ${token}`,
                    // ❌ remove Content-Type for FormData
                },
                body: formData,
            }
        );

        const data = await response.json();

        return data;

    } catch (error) {
        toast.error(error.message || "Something went wrong ❌");
        return null;
    }
};
